import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import i18n from '../../../i18n';
import { scenes } from '@/config/siteImages';

export default function LLCCTASection() {
  const { t } = useTranslation();
  const isEs = i18n.language === 'es';

  return (
    <section className="py-24 bg-[#1a0d24] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <img
          src={scenes.sllcCtaBg}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block text-[#C89EF0] text-sm font-semibold uppercase tracking-widest mb-4">
          {t('sllc_cta_eyebrow')}
        </span>
        <h2 className="text-3xl lg:text-5xl font-bold text-white leading-tight mb-6">
          {t('sllc_cta_title')}
        </h2>
        <p className="text-lg text-white/70 leading-relaxed mb-10 max-w-2xl mx-auto">
          {t('sllc_cta_subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link
            to={isEs ? '/es/contacto' : '/contact'}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg bg-white text-[#4F2D63] font-semibold text-base hover:bg-[#F8F3FB] transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('sllc_cta_primary')}
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to={isEs ? '/es/contacto' : '/contact'}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg border border-white/30 text-white font-semibold text-base hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('sllc_cta_secondary')}
          </Link>
        </div>

        <p className="text-white/40 text-xs">{t('sllc_cta_compliance')}</p>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-6 mt-10 pt-10 border-t border-white/10">
          {[
            { icon: 'ri-shield-check-line', label: t('ty_trust_1') },
            { icon: 'ri-time-line', label: t('ty_trust_2') },
            { icon: 'ri-user-heart-line', label: t('ty_trust_3') },
          ].map((b) => (
            <div key={b.label} className="flex items-center gap-2 text-white/60 text-sm">
              <i className={`${b.icon}`} />
              <span>{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
